import styled from "styled-components";
import { FlexColumn, BaseFlex } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import type { ButtonType } from "@similarweb/ui-components";
import { IconButton } from "@similarweb/ui-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

interface IDiscountPopupTheme {
    background: string;
    giftImageIcon: string;
    CTAButtonType: ButtonType;
    closeButtonColor: string;
    titleColor: string;
    headingColor: string;
    subtitleColor: string;
    discountTextColor: string;
    timeValueColor: string;
    timeLabelColor: string;
    footerTextColor: string;
    timeBoxWrapperBorderColor: string;
    timeBoxWrapperBackground: string;
}

const presidentsDay2025Theme: IDiscountPopupTheme = {
    background: "linear-gradient(218.57deg, #FFD8BC -27%, #FFFFFF 52.71%, #B2C8FF 131.86%)",
    giftImageIcon: "/images/gift-presidents-day.svg",
    CTAButtonType: "primary",
    closeButtonColor: colorsPalettes.carbon[500],
    titleColor: colorsPalettes.carbon[500],
    headingColor: colorsPalettes.carbon[500],
    subtitleColor: colorsPalettes.carbon[500],
    discountTextColor: colorsPalettes.carbon[500],
    timeValueColor: colorsPalettes.carbon[400],
    timeLabelColor: colorsPalettes.carbon[400],
    footerTextColor: colorsPalettes.carbon[400],
    timeBoxWrapperBorderColor: colorsPalettes.sky[100],
    timeBoxWrapperBackground: colorsPalettes.carbon[0],
};

const midnightBlueGradientTheme: IDiscountPopupTheme = {
    background: `linear-gradient(48deg, ${colorsPalettes.midnight[500]} 0%, ${colorsPalettes.blue[400]} 99.18%)`,
    giftImageIcon: "/images/basic-gift.svg",
    CTAButtonType: "inverted",
    closeButtonColor: colorsPalettes.carbon[0],
    titleColor: colorsPalettes.blue[50],
    headingColor: colorsPalettes.bluegrey[100],
    subtitleColor: colorsPalettes.blue[50],
    discountTextColor: colorsPalettes.blue[50],
    timeValueColor: colorsPalettes.carbon[0],
    timeLabelColor: colorsPalettes.carbon[0],
    footerTextColor: colorsPalettes.carbon[50],
    timeBoxWrapperBorderColor: colorsPalettes.carbon[0],
    timeBoxWrapperBackground: `linear-gradient(206deg, ${colorsPalettes.carbon[0]} -155.94%, rgba(255, 255, 255, 0) 135.15%)`,
};

export const theme = midnightBlueGradientTheme;

export const PopupContainer = styled(FlexColumn)`
    gap: 8px;
    position: relative;
    width: 100%;
    border-radius: 4px;
    background: ${theme.background};
    color: ${colorsPalettes.carbon[0]};
    padding: 20px;
    text-align: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    align-items: center;
`;

export const CloseButton = styled(IconButton)`
    position: absolute;
    top: 10px;
    right: 10px;
    div {
        svg {
            path {
                fill: ${theme.closeButtonColor} !important;
            }
        }
    }
`;

export const Title = styled.div`
    ${setFontVariant("sectionTitle", theme.titleColor)};
`;

export const Heading = styled.div`
    ${setFontVariant("h3", theme.headingColor)};
    font-weight: bold;
`;

export const GiftImage = styled.img`
    height: 90px;
    width: 166px;
    margin: 16px 0;
`;

export const Subtitle = styled.div`
    ${setFontVariant("sectionTitle", theme.subtitleColor)};
`;

export const DiscountText = styled.div`
    ${setFontVariant("h1", theme.discountTextColor)};
    font-weight: bold;
`;

export const TimerContainer = styled(BaseFlex)`
    justify-content: center;
    gap: 16px;
    margin: 4px 0 16px 0;
`;

export const TimeBoxWrapper = styled(BaseFlex)`
    justify-content: center;
    flex-direction: column;
    border-radius: 4px;
    border: 1px solid ${theme.timeBoxWrapperBorderColor};
    background: ${theme.timeBoxWrapperBackground};
    backdrop-filter: blur(22px);
    width: 61px;
    height: 64px;
    flex-shrink: 0;
`;

export const TimeValue = styled.div`
    ${setFontVariant("h5_2", theme.timeValueColor)};
    padding-bottom: 5px;
`;

export const TimeLabel = styled.div`
    ${setFontVariant("body2", theme.timeLabelColor)};
`;

export const Disclaimer = styled(BaseFlex)`
    ${setFontVariant("dataTable2", theme.footerTextColor)};
    margin-top: 12px;
`;

export const modalStyles = {
    content: {
        padding: 0,
        width: "auto",
        border: 0,
        background: null,
    },
};
